/* unplugin-vue-components disabled */import { render } from "./pulse-actions.vue?vue&type=template&id=1142527f&scoped=true"
import script from "./pulse-actions.vue?vue&type=script&lang=js"
export * from "./pulse-actions.vue?vue&type=script&lang=js"

import "./pulse-actions.vue?vue&type=style&index=0&id=1142527f&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1142527f"],['__file',"src/pages/pulse/pulse-actions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1142527f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1142527f', __exports__)) {
    api.reload('1142527f', __exports__)
  }
  
  module.hot.accept("./pulse-actions.vue?vue&type=template&id=1142527f&scoped=true", () => {
    api.rerender('1142527f', render)
  })

}


export default __exports__